const Loading = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="text-4xl text-cn-muted-foreground animate-pulse">
        Loading...
      </div>
    </div>
  );
};

export default Loading;
